define('WebReviews.Rating.View', [
    'webreviews_rating.tpl',
    'Backbone',
    'underscore'
], function WebReviewsRatingView(
    webreviewsRatingTpl,
    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        contextDataRequest: ['item'],
        template: webreviewsRatingTpl,
        initialize: function initialize(options) {
            this.fields = (options.config && options.config.fields) ? options.config.fields : null;
        },
        getItem: function getItem() {
            return this.contextData.item();
        },
        getReviews: function getReviews() {
            var fields = this.fields;
            var item = this.getItem();
            var reviews = [];

            if (fields && fields.length) {
                _.each(fields, function each(field) {
                    if (field.abbreviation && field.score) {
                        reviews.push({
                            webReviewReviewer: item[field.reviewer],
                            webReviewScore: item[field.score]
                        });
                    }
                });

                reviews = _.reject(reviews, function reject(review) {
                    return (!review.webReviewReviewer && !review.webReviewScore);
                });
            }

            return reviews;
        },
        getContext: function getContext() {
            var reviews = this.getReviews();
            var showReviews;

            showReviews = !!(reviews.length);

            return {
                reviews: reviews,
                showReviews: showReviews
            };
        }
    });
});
